import {ReferenciaCFEDTO} from './ReferenciaCFEDTO';

export class ReferenciasCFEDTO
{
  tipoReferencia: string;
  referenciaCFE: ReferenciaCFEDTO;
  razonReferencia: string;

  public limpiar(): void
  {
    this.tipoReferencia = null;
    this.referenciaCFE.limpiar();
    this.razonReferencia = null;
  }
}
